import { useContext, useLayoutEffect } from "react";
import { WizardReceipt } from "../common/wizardReceipt";
import { ModalContext } from "../../Modal/Modal";
import Button from "@/components/bricks/button/Button";
import { useNavigate } from "react-router-dom";
import { OpretLinjeQuery } from "./useOpretKursusLinje";

const OpretLinjeReceipt = (props: {
  opretLinjeQuery: OpretLinjeQuery;
  step1;
  step2;
  setStep;
}) => {
  const { opretLinjeQuery, step1, step2, setStep } = props;

  if (opretLinjeQuery.isPending) return <OpretLinjeReceiptLoading />;
  if (opretLinjeQuery.error) {
    return (
      <OpretLinjeReceiptError
        opretLinjeQuery={opretLinjeQuery}
        setStep={setStep}
      />
    );
  }
  if (opretLinjeQuery.data) {
    return (
      <OpretLinjeReceiptSuccess
        opretLinjeQuery={opretLinjeQuery}
        setStep={setStep}
        step1={step1}
        step2={step2}
      />
    );
  }
  return <div>error</div>;
};
export default OpretLinjeReceipt;

const OpretLinjeReceiptLoading = () => {
  return (
    <WizardReceipt heading="Opretter linje ..." icon="loading">
      <p className="text-muted text-center">Dette kan tage et øjeblik</p>
    </WizardReceipt>
  );
};
const OpretLinjeReceiptSuccess = (props: {
  step1;
  step2;
  setStep;
  opretLinjeQuery;
}) => {
  const { opretLinjeQuery, setStep, step1, step2 } = props;

  const navigate = useNavigate();
  const { setModalOpen } = useContext(ModalContext);
  useLayoutEffect(() => {
    setTimeout(() => {
      setModalOpen(false);
      step1.resetForm();
      step2.resetForm();
      setStep(1);
      navigate("/linje/" + (opretLinjeQuery.data as any).id);
    }, 3000);
  }, [navigate, opretLinjeQuery.data, setModalOpen, setStep, step1, step2]);
  return (
    <WizardReceipt heading="Linje oprettet" icon="success">
      <p className="text-muted text-center">
        Henter {opretLinjeQuery.data && (opretLinjeQuery.data as any).navn}
      </p>
    </WizardReceipt>
  );
};
const OpretLinjeReceiptError = (props: { opretLinjeQuery; setStep }) => {
  const { opretLinjeQuery, setStep } = props;

  const { error, reset: resetQuery } = opretLinjeQuery;

  return (
    <>
      <WizardReceipt heading="Noget gik galt" icon="warning">
        <p className="text-muted text-center">
          {(error as any)?.data?.Message ?? "Luk for at afslutte"}
        </p>
      </WizardReceipt>
      <div className="flex-100 d-flex justify-content-center mt-3">
        <Button
          color="secondary"
          onClick={() => {
            setStep(1);
            resetQuery();
          }}
        >
          Tilbage
        </Button>
      </div>
    </>
  );
};
